export function getRoute(scores) {
  // Priority 1: Low AI Familiarity → TRAINING
  if (scores.familiarity <= 5) return "training";

  // Priority 2: Low clarity (Q8) AND not-low familiarity → AUDIT
  if (scores.q8Score <= 2 && scores.familiarity > 5) return "audit";

  // Priority 3: High pain + high readiness + high Q8 clarity → BUILD
  if (scores.pain >= 6 && scores.readiness >= 4 && scores.q8Score >= 3) return "build";

  // Priority 4: Low pain + low readiness → NURTURE
  if (scores.pain <= 5 && scores.readiness <= 3) return "nurture";

  // Priority 5: Fallback → DISCOVERY
  return "discovery";
}
